import React, { useRef } from 'react';
import JoditEditor from 'jodit-react';

const RichTextEditor = () => {
  const editor = useRef(null);
  const [content, setContent] = React.useState('');

  const config = {
    readonly: false, 
    height: '75vh', 
    width: '100%',  
  };

  return (
    <div className="mt-8">
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        onChange={(newContent) => setContent(newContent)}
      />
    </div>
  );
};

export default RichTextEditor;
